import datauritoblob from 'datauritoblob'

const util = {
    putFilterToUrl(query) {
        if (history.replaceState) {
            query = query ?? ''
            const filter = query.length === 0 ? '' : '?filter=' + query
            let newUrl = window.location.protocol + '//' + window.location.host + window.location.pathname + filter
            // Replace the current entry so repeated filter updates don't create a long history stack
            // that breaks the back button (notably in Edge).
            window.history.replaceState({ path: newUrl }, '', newUrl)
        }
    },
    set(o, p) {
        const k = Object.keys(o)
        for (var i = 0; i < k.length; i++) {
            if (Object.prototype.hasOwnProperty.call(p, k[i])) {
                o[k[i]] = p[k[i]]
            }
        }
    },
    push(o, p, k = 'id') {
        for (const i in p) {
            const r = o.find(r => r[k] === p[i][k])
            if (!r) {
                o.push(p[i])
            }
        }
    },
    add(o, p, k = 'id', b = false) {
        const i = o.find(r => r[k] === p[k])
        if (i) {
            Object.assign(i, p)
        } else if (b == true) {
            o.push(p)
        } else {
            o.unshift(p)
        }
    },
    remove(o, p, k = 'id') {
        return o.filter(r => (k === null ? r !== p : r[k] !== p))
    },
    deepCopy(object) {
        return JSON.parse(JSON.stringify(object))
    },
    isDataUrl(str) {
        let regex =
            /^\s*data:([a-z]+\/[a-z]+(;[a-z-]+=[a-z-]+)?)?(;base64)?,[a-z0-9!$&',()*+,;=._~:@/?%-\s]*\s*$/i

        return !!str.match(regex)
    },
    toBlob(data) {
        return datauritoblob(data)
    },
    toFormData(model, form = null, namespace = '') {
        let formData = form || new FormData()
        if (typeof model !== 'object' && namespace) {
            formData.append(namespace, model.toString())
            return formData
        }
        for (let pName in model) {
            if (!Object.hasOwn(model, pName)) continue
            let formKey = namespace ? `${namespace}[${pName}]` : pName
            if (model[pName] instanceof Date) {
                formData.append(formKey, model[pName].toISOString())
            } else if (model[pName] instanceof Array) {
                model[pName].forEach((element, index) => {
                    const tempFormKey = `${formKey}[${index}]`
                    this.toFormData(element, formData, tempFormKey)
                })
            } else if (typeof model[pName] === 'object' && !(model[pName] instanceof File)) {
                this.toFormData(model[pName], formData, formKey)
            } else if (pName === 'file' && model[pName] instanceof File) {
                formData.append(formKey, model[pName])
            } else if (pName === 'file' && !(model[pName] instanceof File)) {
                if (this.isDataUrl(model[pName])) formData.append(formKey, this.toBlob(model[pName]))
            } else {
                formData.append(formKey, model[pName].toString())
            }
        }
        return formData
    },
    formatSeconds(seconds) {
        try {
            const totalSeconds = Number(seconds)
            const hours = Math.floor(totalSeconds / 3600)
            const minutes = Math.floor((totalSeconds % 3600) / 60)
            const secs = totalSeconds % 60

            let parts = []
            if (hours > 0) parts.push(`${hours}h`)
            if (minutes > 0) parts.push(`${minutes}m`)
            if (secs > 0 || parts.length === 0) parts.push(`${secs}s`)

            return parts.join(' ')
        } catch (e) {
            return ''
        }
    },
    formatMilliSeconds(milliseconds) {
        try {
            const totalMilliseconds = Number(milliseconds)

            if (!Number.isFinite(totalMilliseconds)) {
                return ''
            }

            if (totalMilliseconds < 1000) {
                return `${totalMilliseconds}ms`
            }

            const totalSeconds = Math.floor(totalMilliseconds / 1000)
            const millisecondsRemainder = totalMilliseconds % 1000
            const hours = Math.floor(totalSeconds / 3600)
            const minutes = Math.floor((totalSeconds % 3600) / 60)
            const secs = totalSeconds % 60

            let parts = []
            if (hours > 0) parts.push(`${hours}h`)
            if (minutes > 0) parts.push(`${minutes}m`)
            if (secs > 0 || parts.length === 0) parts.push(`${secs}s`)
            if (millisecondsRemainder > 0) parts.push(`${millisecondsRemainder}ms`)

            return parts.join(' ')
        } catch (e) {
            return ''
        }
    },
    has(o, p) {
        return Object.prototype.hasOwnProperty.call(o, p)
    },
    fill(l, o) {
        l.forEach((i, k) => (l[k] = o(i)))
        return l
    },
    get(l) {
        return JSON.parse(JSON.stringify(l))
    },
    toCSV(o, f) {
        let array = JSON.parse(JSON.stringify(o))
        let str = ''
        for (let i = 0; i < array.length; i++) {
            let line = ''
            for (let index in array[i]) {
                if (line != '') line += ','
                line += array[i][index]
            }
            str += line + '\r\n'
        }
        let blob = new Blob([str], { type: 'text/csv;charset=utf-8;' })
        if (navigator.msSaveBlob) {
            navigator.msSaveBlob(blob, f)
        } else {
            let link = document.createElement('a')
            if (link.download !== undefined) {
                let url = URL.createObjectURL(blob)
                link.setAttribute('href', url)
                link.setAttribute('download', f)
                link.style.visibility = 'hidden'
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
            }
        }
    }
}

export default util
